import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const GenerateDepositBarcode = gql`
  mutation GenerateDepositBarcode($input: GenerateBarcodeInput!) {
    generateDepositBarcode(input: $input) {
      ... on GenerateBarcodeSuccess {
        barcodeId
        gdBarcodeId
        gdBarcodeLink
        gdBarcodeIdExpiration
        payloadFormat
        __typename
      }

      ... on GenerateBarcodeError {
        ...error
        __typename
      }
    }
  }
  ${error}
`;

export default GenerateDepositBarcode;
